import { ButtonLink } from 'containers/pages/courses-list/components/styled';
import styled, { CSSObject } from 'styled-components';
import {
    colorBlack,
    colorPrimary,
    colorWhite,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const Wrapper = styled.div<{ styles?: CSSObject }>`
    position: relative;
    overflow: hidden;

    transform-origin: left bottom;
    transform: skewY(3deg);
    border-radius: 0 0 40px 40px;
    margin-bottom: -35px;

    ${({ styles }) => ({ ...styles })};
`;

export const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 670px;
    margin: 0 auto;
    align-items: flex-start;
    gap: 40px;
`;

export const Title = styled.h2`
    font-weight: 400;
    font-size: 81px;
    line-height: 81px;

    @media (${mediaSm}) {
        font-size: 55px;
        line-height: 55px;
    }

    @media (${mediaXs}) {
        font-size: 32px;
        line-height: 32px;
    }
`;

export const Description = styled.p`
    font-size: 24px;
    line-height: 28px;
    font-weight: 300;

    @media (${mediaSm}) {
        font-size: 19px;
        line-height: 24px;
        max-width: 520px;
    }
`;

export const ButtonBlock = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    width: 100%;
    @media (${mediaXs}) {
        flex-direction: column;
    }
`;

export const ButtonLinkInner = styled(ButtonLink)`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: ${colorWhite};
    fill: ${colorWhite};
    background-color: ${colorBlack};
    padding: 8px 32px;
    min-height: 48px;
    &:hover {
        color: ${colorWhite};
        fill: ${colorWhite};
        background-color: ${colorBlack};
        opacity: 0.8;
    }
`;

export const ButtonLinkWhiteInner = styled(ButtonLink)`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: ${colorBlack};
    fill: ${colorBlack};
    background-color: ${colorWhite};
    padding: 8px 32px;
    &:hover {
        color: ${colorBlack};
        fill: ${colorBlack};
        background-color: ${colorWhite};
        opacity: 0.8;
    }
`;

export const ButtonLinkGreenInner = styled(ButtonLink)`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: ${colorWhite};
    fill: ${colorWhite};
    background-color: ${colorPrimary};
    padding: 8px 32px;
    min-height: 48px;
    &:hover {
        color: ${colorWhite};
        fill: ${colorWhite};
        background-color: ${colorPrimary};
        opacity: 0.8;
    }
`;
